import type { ApprovalRequest } from "../chatState.ts";
import { ARG_LABELS, serverLabel, toolLabel } from "../toolLabels.ts";

// Ids and revisions are needed by the tool but say nothing to the seller.
const HIDDEN = new Set(["planId", "businessAreaId", "offeringId", "accountId", "periodId", "expectedRevision"]);

function Field({ name, value }: { name: string; value: unknown }) {
  if (value === null || value === undefined || HIDDEN.has(name)) return null;
  if (typeof value === "object" && !Array.isArray(value)) {
    const v = value as Record<string, unknown>;
    if (typeof v.text === "string") {
      return (
        <div className="approval-field">
          <dt>
            {ARG_LABELS[name] ?? name}
            {v.mode === "replace" ? <span className="badge badge-warn">Ersätter text</span> : <span className="badge">Läggs till</span>}
          </dt>
          <dd className="approval-text">{v.text}</dd>
        </div>
      );
    }
    return (
      <>
        {Object.entries(v).map(([k, val]) => (
          <Field key={k} name={`${name}.${k}`} value={val} />
        ))}
      </>
    );
  }
  const label = ARG_LABELS[name] ?? ARG_LABELS[name.split(".").at(-1) ?? ""] ?? name;
  return (
    <div className="approval-field">
      <dt>{label}</dt>
      <dd>{typeof value === "number" ? value.toLocaleString("sv-SE") : String(value)}</dd>
    </div>
  );
}

export function ApprovalCard({
  request,
  disabled,
  onDecide,
}: {
  request: ApprovalRequest;
  disabled: boolean;
  onDecide: (approve: boolean) => void;
}) {
  const entries = Object.entries(request.args);
  return (
    <section className={`card approval ${request.decision ?? "pending"}`} aria-label="Godkänn ändring">
      <header className="approval-head">
        <span className="overline">
          {serverLabel(request.server, request.name)} · {request.decision ? "beslutat" : "väntar på dig"}
        </span>
        <h3>{toolLabel(request.name)}</h3>
      </header>
      {entries.length > 0 && (
        <dl className="approval-fields">
          {entries.map(([k, v]) => (
            <Field key={k} name={k} value={v} />
          ))}
        </dl>
      )}
      {request.decision ? (
        <p className="approval-result">{request.decision === "approved" ? "Godkänt – agenten skriver nu." : "Avvisat – inget skrevs."}</p>
      ) : (
        <div className="approval-actions">
          <button className="btn btn-primary" disabled={disabled} onClick={() => onDecide(true)}>
            Godkänn och skriv
          </button>
          <button className="btn btn-secondary" disabled={disabled} onClick={() => onDecide(false)}>
            Avvisa
          </button>
        </div>
      )}
    </section>
  );
}
